<template>
    <div class="footer">
        <el-row :gutter="20" class="footer-content">
            <el-col :span="8">
                <div class="grid-content bg-purple">
                    <h3>关于</h3>
                    <div>
                        <p>关于我们</p>
                        <p>关注我们</p>
                        <p>联系我们</p>
                    </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple">
                    <h3>帮助</h3>
                    <div>
                        <p>常见问题</p>
                        <p>系统更新日志</p>
                        <p>API文档</p>
                    </div>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple">
                    <h3>友情链接</h3>
                    <div>
                        <p>okex</p>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="name">
            <strong>Copyright</strong> 恒石科技 1.0 &copy; 2019
        </div>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    data () {
        return {}
    },
    inject: ['reload'],
    mounted () {
        this.theDistanceOfTop();
    },
    methods: {
        // 判断footer到顶部的距离
        theDistanceOfTop() {
            if ($('.footer').length !== 0) {
                var toTop = $('.footer').offset().top;
                var height = window.screen.availHeight;
                var toBottom = height - toTop -258;
                // console.log(toTop, toBottom, height);
                if (toBottom >= 0) {
                    $('.footer').css('margin-top', toBottom+'px');
                } else if (toBottom < 0) {
                    $('.footer').css('margin-top', 10+'px');
                }
            }
        },
    }
}
</script>

<style lang="scss">
    .footer{
        // padding: 10px;
        background-color: #000;
        color: #686869;
        width: 100%;
        // margin: 30px 0;
        .footer-content{
            width: 70%;
            margin: 0 auto !important;
        }
        h3{
            padding: 5px;
        }
        p{
            padding: 3px;
            font-size: 13px;
        }
        p:hover{
            cursor: pointer;
            color: #fff;
        }
        .name{
            padding: 20px;
            font-size: 13px;
        }
    }
</style>
